/* src/app/builder-screen-beta/floating-inspector/property-presets-modal.component.scss */
.presets-modal-content {
  padding: 0;
}
.presets-modal-content .component-type-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
}
.presets-modal-content .component-type-header .component-type-label {
  color: #8c8c8c;
  font-size: 14px;
}
.presets-modal-content .presets-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
  max-height: 400px;
  overflow-y: auto;
  padding: 4px;
}
.presets-modal-content .presets-grid .preset-card {
  position: relative;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 2px solid transparent;
}
.presets-modal-content .presets-grid .preset-card.selectable:hover {
  border-color: #d9d9d9;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.presets-modal-content .presets-grid .preset-card.active {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}
.presets-modal-content .presets-grid .preset-card .preset-preview {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  background: #fafafa;
  border-radius: 6px;
  margin-bottom: 12px;
}
.presets-modal-content .presets-grid .preset-card .preset-preview .preview-icon {
  font-size: 24px;
  color: #1890ff;
}
.presets-modal-content .presets-grid .preset-card .preset-info .preset-name {
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #262626;
  line-height: 1.2;
}
.presets-modal-content .presets-grid .preset-card .preset-info .preset-description {
  margin: 0 0 12px 0;
  font-size: 14px;
  color: #8c8c8c;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.presets-modal-content .presets-grid .preset-card .preset-info .preset-tags {
  margin-bottom: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.presets-modal-content .presets-grid .preset-card .preset-info .preset-popularity {
  display: flex;
  align-items: center;
  gap: 8px;
}
.presets-modal-content .presets-grid .preset-card .preset-info .preset-popularity .popularity-text {
  color: #8c8c8c;
  font-size: 12px;
}
.presets-modal-content .presets-grid .preset-card .selection-indicator {
  position: absolute;
  top: 8px;
  right: 8px;
  font-size: 20px;
}
.presets-modal-content .no-presets-state {
  padding: 40px 20px;
  text-align: center;
}
.presets-modal-content .preset-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}
.presets-modal-content .preset-actions .action-group {
  display: flex;
  gap: 8px;
}
.presets-modal-content .preset-actions .action-group.secondary {
  justify-content: flex-start;
}
.presets-modal-content .preset-actions .action-group.primary {
  justify-content: flex-end;
}
@media (max-width: 768px) {
  .presets-modal-content .presets-grid {
    grid-template-columns: 1fr;
    max-height: 300px;
  }
  .presets-modal-content .preset-actions {
    flex-direction: column;
    gap: 12px;
  }
  .presets-modal-content .preset-actions .action-group {
    width: 100%;
    justify-content: center;
  }
  .presets-modal-content .preset-actions .action-group.primary {
    order: -1;
  }
}
[data-theme=dark] .presets-modal-content .component-type-header {
  border-bottom-color: #303030;
}
[data-theme=dark] .presets-modal-content .presets-grid .preset-card .preset-preview {
  background: #1f1f1f;
}
[data-theme=dark] .presets-modal-content .presets-grid .preset-card .preset-info .preset-name {
  color: #ffffff;
}
[data-theme=dark] .presets-modal-content .presets-grid .preset-card .preset-info .preset-description {
  color: #bfbfbf;
}
[data-theme=dark] .presets-modal-content .presets-grid .preset-card.selectable:hover {
  border-color: #434343;
}
[data-theme=dark] .presets-modal-content .preset-actions {
  border-top-color: #303030;
}
/*# sourceMappingURL=property-presets-modal.component.css.map */
